import * as leaflet from 'leaflet';

export enum LeafletMapTiles {
  DEFAULT = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  TONER = 'http://{s}.tile.stamen.com/toner/{z}/{x}/{y}.png'
}

export interface LeafletMarkerOptions extends Omit<leaflet.MarkerOptions, "icon"> {
  position: leaflet.LatLngExpression;
  iconUrl?: string;
  iconSize?: [number, number];
}

export interface LeafLetMapOptions {
  center: leaflet.LatLngExpression;
  zoom: number;
  markers?: LeafletMarkerOptions[];
  tiles?: LeafletMapTiles;
}

export class LeafletMap {
  private map: leaflet.Map;

  private constructor(
    private el: HTMLDivElement,
    private options: LeafLetMapOptions
  ) {
    const tiles = LeafletMapTiles.DEFAULT;
    this.map = leaflet.map(this.el)
    leaflet.tileLayer(tiles, {
      attribution: 'Map data &copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
    }).addTo(this.map);
    this.map.setView(options.center, options.zoom);
  }

  public markers(): void {
    if (!this.options.markers) return;
    this.options.markers.forEach((markerOptions) => {
      const marker = leaflet.marker(markerOptions.position, {
        ...markerOptions,
        icon: leaflet.icon({
          iconUrl: markerOptions.iconUrl || 'https://cdn.future-factory.org/map-pin.png',
          iconSize: markerOptions.iconSize || [40, 75]
        }),
      });
      marker.addTo(this.map);
    });
  }

  public invalidateSize(): void {
    this.map.invalidateSize();
  }


  public static create(
    el: HTMLDivElement,
    options: LeafLetMapOptions
  ): LeafletMap {
    return new LeafletMap(el, options);
  }
}
